import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {TimezoneModel} from '@features/newsletter/models/timezone.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {getAllCountries, ParticleState} from '@shared/store/reducers/particle.reduer';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-platform-tool-newsletter-content',
  templateUrl: './platform-tool-newsletter-content.component.html',
  styleUrls: ['./platform-tool-newsletter-content.component.scss']
})
export class PlatformToolNewsletterContentComponent implements OnInit, OnDestroy, IPlatformToolComponent  {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  time: any =  new Date(2021, 6, 30, 0, 0, 0);
  allTimeZones: TimezoneModel[];
  outputDateTime: any;
  selectorForm: FormGroup;
  configKey = 'ExpertCornerCountries';
  selectedCountryCodes = [];
  private unsubscribe$ = new Subject<void>();
  countryCodes: any[];
  eyCountryCodes: any[];
  selectedEyCountryCodes: any[];
  selectedOrbitaxCountryCodes: any[];
  selectedPageroCountryCodes: any[];
  isReady: boolean;
  selectedTimezone: any;
  availableTimePeriods: string[];
  timePeriod: string;
  constructor(private formBuilder: FormBuilder, private particleStore: Store<ParticleState>) {
    this.isReady = false;
    this.getTimesOptions();
  }

  ngOnInit(): void {
    this.selectorForm = this.formBuilder.group({
      timezone: ['', Validators.required],
    });
    this.allTimeZones =  this.magicLinkModel?.tabBar?.tabs[0]?.tabData['TimeZones'];
    this.selectedOrbitaxCountryCodes =  this.selectedTab?.tabData['OrbitaxCountries'];
    this.selectedEyCountryCodes =  this.selectedTab?.tabData['EyCountries'];
    this.selectedPageroCountryCodes =  this.selectedTab?.tabData['PageroCountries'];
    const selectedTimeZone =  this.selectedTab?.tabData['SelectedTimezone'];
    const selectedTime  =  this.selectedTab?.tabData['SelectedTime'];
    const selectedTimeString = this.selectedTab?.tabData['SelectedTimeString'];
    if (selectedTimeZone) {
      this.allTimeZones.forEach(t => {
        if (t.id === selectedTimeZone.id) {
          this.selectedTimezone = t.id;
        }
      });
    }
    if (!this.selectedTimezone) {
      const offset = this.getCurrentTimeOffset();
      console.log(offset);
      const region = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let isTimeZonefound = false;
      this.allTimeZones.forEach(t => {
        if (t.offset.toString() === offset.toString() && t.regions.includes(region) ) {
          this.selectedTimezone = t.id;
          isTimeZonefound = true;
        }
      });
      if (!isTimeZonefound) {
        this.selectedTimezone = this.allTimeZones.find((t) => t.offset.toString() === offset.toString())?.id;
      }
    }
    this.handler.metaData['SelectedTimezoneId'] = this.selectedTimezone;
    if (!selectedTimeString) {
      this.timePeriod = this.availableTimePeriods.length !== 0 ? this.availableTimePeriods[0] :'';
    } else {
      this.timePeriod = selectedTimeString;
    }
    this.handleChange(this.timePeriod);
    this.particleStore.pipe(select(getAllCountries)).pipe(takeUntil(this.unsubscribe$))
      .subscribe((countries: any) => {
        if (countries) {
          if (this.selectedOrbitaxCountryCodes === null) {
            this.selectedOrbitaxCountryCodes = countries.map(c => c.code);
          }
          if (this.selectedEyCountryCodes === null) {
            this.selectedEyCountryCodes = countries.map(c => c.code);
          }
          if (this.selectedPageroCountryCodes === null) {
            // because we didn't run migration script for pagero
            this.selectedPageroCountryCodes = [];
          }
          this.isReady = true;
        }
      }, err => {
        console.error('Can not fetch country list ', err);
      });
  }

  private getCurrentTimeOffset() {
    const date = new Date();
    const offset = date.getTimezoneOffset() / (-60);
    return offset;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }
  onCountrySelectionChanged($event) {
    if ($event && $event.length > 0 && $event[0].isRegionSelected) {
      this.handler.metaData['SelectedCountryCodes'] = $event.filter(country => country.id).map(c => c.country.id.toUpperCase());
    } else {
      this.handler.metaData['SelectedCountryCodes'] = $event.map(c => c.id.toUpperCase());
  }
  }

  // this.selectorForm.get('timezone').value;
  public handleChange(timePeriod: any) {
    const position = timePeriod.trim().indexOf(':');
    const parsedTimePeriod = timePeriod.trim().substring(0, position);
    console.log(`parse (${parsedTimePeriod})`);
    const today = new Date();
    const value = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(parsedTimePeriod), 0, 0);
    const userTimezoneOffset = value.getTimezoneOffset() * 60000;
    this.outputDateTime = new Date(value.getTime() - userTimezoneOffset);
    this.handler.metaData['SelectedTime'] = this.outputDateTime;
    this.handler.metaData['SelectedTimePeriod'] = timePeriod;
  }

  onEYCountrySelectionChanged($event: any) {
    if ($event && $event.length > 0 && $event[0].isRegionSelected) {
      this.handler.metaData['SelectedEYCountryCodes'] = $event.filter(country => country.id).map(c => c.country.id.toUpperCase());
    } else {
      this.handler.metaData['SelectedEYCountryCodes'] = $event.map(c => c.id.toUpperCase());
    }
  }
  onPageroCountrySelectionChanged($event: any) {
    if ($event && $event.length > 0 && $event[0].isRegionSelected) {
      this.handler.metaData['SelectedPageroCountryCodes'] = $event.filter(country => country.id).map(c => c.country.id.toUpperCase());
    } else {
      this.handler.metaData['SelectedPageroCountryCodes'] = $event.map(c => c.id.toUpperCase());
    }
  }

  onSelectionChange($event: any) {
    this.handler.metaData['SelectedTimezoneId'] = $event.value;
  }
  getTimesOptions() {
    this.availableTimePeriods = [
    '08:00 AM',
    '09:00 AM',
    '10:00 AM',
   '11:00 AM',
    '12:00 PM',
    '13:00 PM',
    '14:00 PM',
    '15:00 PM',
    '16:00 PM',
    '17:00 PM',
    '18:00 PM',
    '19:00 PM',
    '20:00 PM',
    '21:00 PM',
    '22:00 PM',
    '23:00 PM'
    ];
  }

  private getTimePeriod() {
    const localDeliveryTime = new Date('11/11/2021 08:00:00 AM UTC');
    return this.availableTimePeriods[localDeliveryTime.getMinutes() > 0 ? localDeliveryTime.getHours() + 1 : localDeliveryTime.getHours()];
  }
}
